// // src/components/QrScanner.jsx
import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { errorToaster, successToaster } from 'utils/helpers/common/alert-service';
import { Host_APIS } from 'libs/apis/host.api';
import { AiOutlineClose } from "react-icons/ai";


const QrScanner = ({ isOpen, onClose ,setIsScannerModalOpen,scannedData, setScannedData,handleScanAgain , closeMe}) => {
  const isScannerStopped = useRef(false);

  useEffect(() => {
    if (!isOpen || scannedData !== null) return;

    const qrRegionId = "qr-reader";
    const html5QrCode = new Html5Qrcode(qrRegionId);

    const config = {
      fps: 10,
      qrbox: { width: 250, height: 250 }
    };

    const onScanSuccess = async (decodedText) => {
      if (isScannerStopped.current) return;

      isScannerStopped.current = true;
      html5QrCode.stop().then(() => {
        console.log("QR Code scanning stopped.");
      }).catch(err => console.error("Stop failed", err));

      await onDetect(decodedText);
    };

    async function onDetect(rawValue) {
      closeMe();
      const parts = rawValue.split("_");

      if (parts.length === 7) {
        const userName = parts[0];
        const userHandle = parts[1];
        const userProfile = parts[2];
        const eventId = parts[3];
        const attendeeId = parts[4];
        const childId = parts[5];
        const workShopId = parts[6];

        setScannedData({ userName, userHandle, userProfile, eventId, attendeeId, childId, workShopId });

        const markAttendance = await Host_APIS.markAttendance(eventId, attendeeId, childId, workShopId);
        successToaster(markAttendance?.message);
      } else {
        errorToaster(`Invalid QR format.`);
        onClose();
      }
    }

    Html5Qrcode.getCameras().then(cameras => {
      if (cameras && cameras.length) {
        html5QrCode.start(
          { facingMode: "environment" },
          config,
          onScanSuccess,
          () => { }
        );
      }
    }).catch(err => console.error("Camera access error:", err));

    return () => {
      if (!isScannerStopped.current) {
        isScannerStopped.current = true;
        html5QrCode.stop().catch(err => console.error("Stop failed", err));
      }
    };
  }, [isOpen,scannedData]);



 
  

  return (
    <>
      {/* Scanner Overlay */}
      {isOpen && !scannedData && (
        <div className="flex justify-center items-center h-screen w-screen bg-black bg-opacity-50 fixed top-0 left-0" style={{ zIndex: 'calc(var(--z-modal) + 1)' }}>
          <div id="qr-reader" style={{ width: "500px" }}></div>
        </div>
      )}

     
    </>
  );
};

export default QrScanner;
